import { z } from "zod";

// Breakdown / group-by dimensions (mirror the backend's allowed throughput group keys; "" = overall).
export const throughputGroupBy = z.enum([
  "",
  "client",
  "lob",
  "engagementType",
  "assignedTo",
]);

const sortDir = z.enum(["asc", "desc"]);

export const throughputSchema = z.object({
  // Period: "last N months" preset, or a custom from/to as "YYYY-MM".
  months: z.number().int().positive().default(3),
  from: z.string().optional(),
  to: z.string().optional(),

  // View
  tab: z.enum(["overview", "requests"]).default("overview"),
  breakdown: throughputGroupBy.default(""),
  chartMode: z.enum(["grouped", "overlay", "line"]).default("grouped"),
  showBacklog: z.boolean().default(false),
  bdSortKey: z.string().default("started"),
  bdSortDir: sortDir.default("desc"),

  // Requests-tab drill state
  basis: z.enum(["started", "completed", "open"]).default("started"),
  drillMonth: z.string().optional(),
  drillSegKey: throughputGroupBy.default(""),
  drillSegVal: z.string().optional(),

  // Categorical filters (rail). onboardingsOnly defaults ON = the full-onboarding ≥7 bucket.
  onboardingsOnly: z.boolean().default(true),
  redeployment: z.boolean().default(false),
  requestType: z.array(z.string()).default([]),
  client: z.array(z.string()).default([]),
  lob: z.array(z.string()).default([]),
  eng: z.array(z.string()).default([]),
  assigned: z.array(z.string()).default([]),
  country: z.array(z.string()).default([]),
});

export type ThroughputState = z.infer<typeof throughputSchema>;
export const THROUGHPUT_DEFAULTS = throughputSchema.parse({});
